const chat = {
    started: false,
    options: {},
    onLoad() {
        window.Tawk_API.setAttributes(
            {
                name: this.options.name,
                email: this.options.email,
            },
            function (error) {},
        );
        let tags = [this.options.place];
        if (this.options.branch) {
            tags.push(this.options.place + " - " + this.options.branch);
        }
        window.Tawk_API.addTags(tags);
    },
    init(options) {
        if (!this.started) {
            this.options = options;
            this.started = true;

            (function () {
                var s1 = document.createElement("script"),
                    s0 = document.getElementsByTagName("script")[0];
                s1.async = true;
                s1.src =
                    "https://embed.tawk.to/5fc0541b920fc91564cb17ac/1eo7lcl3c";
                s1.charset = "UTF-8";
                s1.setAttribute("crossorigin", "*");
                s0.parentNode.insertBefore(s1, s0);
            })();
        }
    },
};

(window.Tawk_API = window.Tawk_API || {}), (window.Tawk_LoadStart = new Date());
window.Tawk_API.onLoad = () => {
    chat.onLoad();
};

export default chat;
